import React from 'react'
import Sobre from '../../assets/images/sobre/shutter-sobre@3x.png'
import MarcaImg from '../../assets/images/marca-alelo.png'
import './style.scss'

export default function SectionUseTime() {
	return (
		<section className="container-section-use-time">
			<div className="container-img">
				<img width="100%" height="100%" alt="Sobre" src={Sobre} />
			</div>
			<div className="container-texts">
				<h1>
					Use o seu tempo com o que realmente importa.
				</h1>
				<div className="description calibri">
					<p>
					Chegamos pra descomplicar seu dia a dia e deixar seu trajeto mais fluído. Somos um novo meio de pagamento automático para uso em pedágios e estacionamentos.
					<br /> 
					<br />
					E em breve, você também poderá utilizar Veloe em postos de combustíveis, drive thru, pagamento de pedágios para motos e muito mais. Tá esperando o que para dar adeus às filas?
					</p>
					<img style={{marginTop: -10}} height="30px" alt="Uma marca Alelo" src={MarcaImg} />
				</div>
			</div>
		</section>
	)
}